import { useMemo } from 'react';
import sortBy from 'lodash/sortBy';

import type { SkillTaxonomyDto } from '@eva/types/dto';

import type { UseQueryResult } from 'react-query/types/react/types';

export const useFetchSkillTaxonomies = (
  useFetchSkillTaxonomyOptions: () => UseQueryResult<{
    skillTaxonomies: SkillTaxonomyDto[];
  }>,
) => {
  const { isLoading, isError, error, data } = useFetchSkillTaxonomyOptions();

  const values = useMemo(() => {
    const sortedSkillTaxonomies =
      data && data.skillTaxonomies
        ? {
            skillTaxonomies: sortBy(data.skillTaxonomies, [(skillTaxonomy) => skillTaxonomy.name.toLocaleLowerCase()]),
          }
        : data;

    return {
      isLoading,
      isError,
      error,
      data: sortedSkillTaxonomies,
    };
  }, [isLoading, isError, error, data]);

  return values;
};
